module.exports = __webpack_public_path__ + "assets/feedbackicon-3.3a1aa9a3.svg";